import React from 'react';
import { IconProps } from '../types';

export const CorporateVideosIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_8892_8460)">
            <path
                d="M10.9999 1.98926L26.3333 6.58926V13H24.3333V8.07732L12.9999 4.67732V9.66662H10.9999V1.98926Z"
                fill={color}
            />
            <path d="M10.3333 17H5.66659V19H10.3333V17Z" fill={color} />
            <path d="M5.66659 21H10.3333V23H5.66659V21Z" fill={color} />
            <path d="M5.66659 25H10.3333V27H5.66659V25Z" fill={color} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.333252 11.6666H15.6666V30.3333H24.3333V24.3333H26.3333V32.3333H0.333252V11.6666ZM13.6666 30.3333V13.6666H2.33325V30.3333H13.6666Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.3488 18.6665L18.9999 11.61V25.7231L31.3488 18.6665ZM27.3177 18.6665L20.9999 22.2767V15.0564L27.3177 18.6665Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_8892_8460">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
